import { render, staticRenderFns } from "./detail3.vue?vue&type=template&id=d2c54ac6&scoped=true"
import script from "./detail3.vue?vue&type=script&lang=js"
export * from "./detail3.vue?vue&type=script&lang=js"
import style0 from "./detail3.vue?vue&type=style&index=0&id=d2c54ac6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c54ac6",
  null
  
)

export default component.exports